import React, { useEffect, useState } from 'react';
import './ReadMore.css';
import { useMediaQuery } from 'react-responsive';
import { ReadMoreDataType } from '../../pages/OutStationOneWayPage/OutStationWayDataChecker';
import { trackOneWayCabPageEvent } from '../../utils/omnitureTracking';

export interface ReadMoreProps {
  data: ReadMoreDataType[];
}

const ReadMoreContent = ({ content, isMobileDevice }) => {
  const [isShow, setShow] = useState(true);
  useEffect(() => {
    if (isShow) {
      setShow(false);
    }
  }, []);

  const onClickViewMore = () => {
    const omniString = isShow ? 'View Less' : 'View More';
    trackOneWayCabPageEvent(`Cab_SEO_OS_OW_${omniString}_Click`);
    setShow(!isShow);
  };
  return (
    <div className={`${isMobileDevice ? 'appendBottom10' : ''}`}>
      <span
        className={`lineHeight20 makeInline paddingTop5 font14`}
        dangerouslySetInnerHTML={{
          __html: `${(() => {
            if (isShow) return content.description;
            else return content.shortDescription;
          })()}`
        }}
      />
      {content.description.length > 350 && (
        <span className="makeInline">
          <a onClick={onClickViewMore}>
            {!isShow ? 'View More' : 'View Less'}{' '}
          </a>
        </span>
      )}
    </div>
  );
};

const ReadMore = (props: ReadMoreProps) => {
  const { data } = props;
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  if (data && data?.length) {
    return (
      <div className="aboutMMT">
        <article className={`landingContainer makeFlex grid`} itemScope>
          {data.map((content, index) => {
            const key = `footerContent-${index}`;
            return (
              <div key={key} className="aboutDesc">
                <h2
                  className="font16 latoBlack blackText appendBottom10"
                  dangerouslySetInnerHTML={{ __html: content.title }}
                />
                <div>
                  <div>
                    <ReadMoreContent
                      content={content}
                      isMobileDevice={isMobileDevice}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </article>
      </div>
    );
  }
  return null;
};

export default ReadMore;
